import React, { useState, useEffect } from 'react'
import { QuickLinksSection } from './QuickLinksSection'

import { WidgetsSection } from './WidgetsSection'
import { QuickLink, PinBoardWidget } from '../../types'
import { pinBoardApi } from '../../services/api'

export const PinBoard: React.FC = () => {
  const [quickLinks, setQuickLinks] = useState<QuickLink[]>([])

  const [widgets, setWidgets] = useState<PinBoardWidget[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    loadPinBoardData()
  }, [])

  const loadPinBoardData = async () => {
    try {
      setLoading(true)
      
      // Load all pin board data in parallel
      const [quickLinksResponse, widgetsResponse] = await Promise.all([
        pinBoardApi.getQuickLinks(),
        pinBoardApi.getWidgets()
      ])

      if (quickLinksResponse.success) {
        setQuickLinks(quickLinksResponse.data)
      }

      if (widgetsResponse.success) {
        setWidgets(widgetsResponse.data)
      }
    } catch (error) {
      console.error('Failed to load pin board data:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleQuickLinksChange = () => {
    // Reload quick links when changed
    pinBoardApi.getQuickLinks().then(response => {
      if (response.success) {
        setQuickLinks(response.data)
      }
    })
  }



  const handleWidgetsChange = () => {
    // Reload widgets when changed
    pinBoardApi.getWidgets().then(response => {
      if (response.success) {
        setWidgets(response.data)
      }
    })
  }

  if (loading) {
    return (
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <h2 className="text-xl font-bold text-gray-900 mb-4">Pin Board</h2>
        <div className="flex items-center justify-center py-8">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-sky-500"></div>
        </div>
      </div>
    )
  }

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-bold text-gray-900">Pin Board</h2>
        <p className="text-sm text-gray-600">
          Customize your workspace with quick links, notes, and embedded content
        </p>
      </div>

      <div className="space-y-6">
        {/* Quick Links Section */}
        <QuickLinksSection 
          quickLinks={quickLinks} 
          onQuickLinksChange={handleQuickLinksChange}
        />



        {/* Widgets Section */}
        <WidgetsSection 
          widgets={widgets} 
          onWidgetsChange={handleWidgetsChange}
        />
      </div>
    </div>
  )
}
